import { isEmpty, find, map, kebabCase } from 'lodash'

export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view

function mapItem (item) {
  const mappedItem = item
  mappedItem['brands'] = {}
  if (!isEmpty(item.gameFiles)) {
    for (const gameFile of item.gameFiles) {
      if (gameFile.brand && gameFile.latestVersion) {
        mappedItem.brands[gameFile.brand.name] = 'Play' || null
      }
    }
  }
  return mappedItem
}

export const tableItems = state => {
  return map(state.items, (item) => {
    const mappedItem = mapItem(item)
    const returnItem = {
      data: mappedItem,
      columns: [
        { field: 'name', value: mappedItem.name, type: 'string' },
        { field: 'active', value: mappedItem.active, type: 'boolean' },
        { field: 'description', value: mappedItem.description, type: 'text', textDisplay: 'nowrap' }
      ]
    }
    returnItem.columns = returnItem.columns.concat(map(brandHeaders(state), (header) => {
      return { field: header.value, value: mappedItem.brands[header.text], type: 'link' }
    }))
    return returnItem
  })
}

export const brandHeaders = state => {
  const returnHeaders = []
  state.items.forEach(function (item) {
    if (!isEmpty(item.gameFiles)) {
      item.gameFiles.forEach(function (gameFile) {
        if (gameFile.brand) {
          const brandAlreadyAdded = find(returnHeaders, ['text', gameFile.brand.name])
          if (!brandAlreadyAdded) {
            returnHeaders.push({ text: gameFile.brand.name, value: kebabCase(gameFile.brand.name) })
          }
        }
      })
    }
  })
  return returnHeaders
}

export const setActiveError = state => state.setActiveError
export const isActiveLoading = state => state.isActiveLoading
